import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Toys(props: StickerArtProps) {
  return (
    <StickerFrame background="#0891b2" {...props}>
      <rect x="13" y="33" width="18" height="18" rx="2.5" fill="#ffffff" />
      <rect x="33" y="33" width="18" height="18" rx="2.5" fill="#ef4444" stroke="#ffffff" strokeWidth="2" />
      <rect x="23" y="13" width="18" height="18" rx="2.5" fill="#facc15" stroke="#ffffff" strokeWidth="2" />
      <circle cx="22" cy="42" r="4" fill="#1f2937" />
      <path d="M32 18 L36 26 H28 Z" fill="#1f2937" />
    </StickerFrame>
  );
}
